import { render, staticRenderFns } from "./group-photo.vue?vue&type=template&id=9164d314&scoped=true"
import script from "./group-photo.vue?vue&type=script&lang=js"
export * from "./group-photo.vue?vue&type=script&lang=js"
import style0 from "./group-photo.vue?vue&type=style&index=0&id=9164d314&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9164d314",
  null
  
)

export default component.exports